import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AiAdminRoutingModule } from './ai-admin-routing.module';
import { AppCommon2Module } from '../../common2/common.module';

// Pages
import { AiAdminShellComponent } from './pages/ai-admin-shell/ai-admin-shell.component';
import { AiDashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { AiSettingsPageComponent } from './pages/settings-page/settings-page.component';

@NgModule({
    declarations: [
        AiAdminShellComponent,
        AiDashboardPageComponent,
        AiSettingsPageComponent,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AiAdminRoutingModule,
        AppCommon2Module,
    ],
    exports: [
        AiSettingsPageComponent,
    ]
})
export class AiAdminModule { }
